import React, { forwardRef } from 'react';
import MonthlyHeader from './monthlyHeader';
import MonthlyTable from './monthlyTable';
import { isEmpty } from 'lodash';

const MonthlyStatementPrint = forwardRef((props, ref) => {
  const { cbpDailyData, statementPrintDate, countryName } = props;

  const formatMoney = (num) => {
    let value =
      num &&
      !isEmpty(num) &&
      num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    if (value === 'NaN') {
      value = '0.00';
    }
    return value;
  };

  return (
    <center ref={ref}>
      <div className='invoicePrint'>
        <MonthlyHeader
          cbpDailyData={cbpDailyData}
          formatMoney={formatMoney}
          statementPrintDate={statementPrintDate}
        />
        <MonthlyTable
          cbpDailyData={cbpDailyData}
          formatMoney={formatMoney}
          countryName={countryName}
        />
      </div>
    </center>
  );
});

export default MonthlyStatementPrint;
